import React, {Component, PropTypes} from 'react'
import Helmet from 'react-helmet'
import {Grid} from 'react-bootstrap'
import {connect} from 'react-redux'
import Elm from 'react-elm-components'
import SimplifiedRequestDetailComponent from '../../elm/src/SimplifiedRequestDetail.elm'
import config from '../config'
import icons from '../core/components/Icon.less'
import {apiOption, apiResponse, apiUrl} from '../core/fetchz'
import {updateOpenTicketCmd} from '../ticket/actions'
import {push} from 'react-router-redux'


const getRandomInts = (n) => {
    const randInts = new Uint32Array(n)
    crypto.getRandomValues(randInts)
    return Array.from(randInts)
}

class SimplifiedRequestDetail extends Component {

    setupPorts = (ports) => {
        ports.dispatch.subscribe(this.subscribeDispatch)
    }

    subscribeDispatch = (msg) => {
        const {dispatch, authenticated} = this.props
        const {companyUid, categoryUid, patrimonyUid, userUid, request, requestUid, contactToCallback} = msg

        Promise.all([
            fetch(apiUrl(config.api.url + '/patrimonycontacts', {patrimonyuids: patrimonyUid}), apiOption())
                .then(apiResponse)
                .then(({json}) => {
                    const {result} = json
                    return result.find(c => c.patrimonyUserState && c.patrimonyUserState.userUid === userUid)
                })
            , fetch(apiUrl(config.api.url + '/patrimonies/'+patrimonyUid), apiOption())
                .then(apiResponse)
                .then(({json}) => {
                    // 1er complementary checker
                    // ou 1er addresses checker
                    // ou 1er complementary
                    // ou 1er addresses
                    return json
                })

        ])
        .then(([user, patrimony]) => {
                const {addresses, complementaryAddresses} = patrimony
                const {uid, checker, geoLocation, building, ...addr} = complementaryAddresses.find(a => a.geolocation)
                || addresses.find(a => a.geolocation)
                || complementaryAddresses[0]
                || addresses[0]
                let action = updateOpenTicketCmd({
                    locationRef: {
                        locationReferenceType: 'PatrimonyLocation',
                        patrimonyUid: patrimony // uniquement dans le store, la patrimonyUid est extrait après
                    },
                    ticket: {
                        callerz: {
                            callerType: 'ReferencedContactCaller',
                            uid: user
                        },
                        address: addr,
                        contactToCallback,
                        request: 'Description du demandeur: ' + request + '\n'
                    },
                    company: {
                        uid: companyUid
                    },
                    otp: {
                        criteria : {
                            categoryUid
                        }
                    },
                    requestUid: requestUid,
                    skipActor: true,
                })
                dispatch(action)

                if (authenticated.userType === 'callCenterOperator' || authenticated.userType === 'callCenterUser') {
                    dispatch(push('/openticket'))
                    return
                }
                dispatch(push('/tickets/new'))
            }
        )
    }


    render() {
        const randInts = getRandomInts(5)
        const {routeParams} = this.props

        return (
            <div>
                <Helmet title='Demande' />
                <Grid>
                    <Elm src={SimplifiedRequestDetailComponent.Elm.SimplifiedRequestDetail} ports={this.setupPorts} flags={{apiUrl: config.api.url, requestUid: routeParams.id, seedInfos : [randInts[0], randInts.slice(1)]}}/>
                </Grid>
            </div>
        )
    }
}

export default connect((state) => ({
    authenticated: state.user.authenticated,
}))(SimplifiedRequestDetail)


// WEBPACK FOOTER //
// ./lib/simplifiedRequest/SimplifiedRequestDetail.js